<template>
  <div id="reports m">
    <no-multi-channel-service v-if="noEvidenceImage" />
    <div v-if="!noEvidenceImage">
      <div class="row m-t-xl">
        <div class="col-lg-6">
          <table class="table table-bordered bg-white">
            <tbody>
              <tr>
                <td class="product-report-item-title">商品レポート（Amazon倉庫）</td>
                <td class="text-center product-report-item-title">
                  <button
                    class="btn btn-primary w-254 btn-report-item-registed"
                    data-toggle="modal"
                    data-target="#productDownload"
                    ref="productDownload"
                    @click="openModalDownload('amazon')"
                  >
                    ダウンロード
                  </button>
                </td>
              </tr>
              <tr>
                <td class="product-report-item-title">レポート（ヤマト運輸倉庫）</td>
                <td class="text-center product-report-item-title">
                  <button
                    class="btn btn-primary w-254 btn-report-item-registed"
                    data-toggle="modal"
                    data-target="#productDownload"
                    ref="productDownload"
                    @click="openModalDownload('salmon')"
                  >
                    ダウンロード
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-6"></div>
      </div>
    </div>
    <product-download
      v-if="isShowDownload"
      :warehouseType="warehouseType"
      @close="closeModalDownload"
    />
  </div>
</template>
<script>
import ProductDownload from './ProductNewModalDownload.vue'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import NoMultiChannelService from '@/components/NoMultiChannelService'
import { mapGetters } from 'vuex'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ProductDownload,
    NoMultiChannelService
  },
  data () {
    return {
      isShowDownload: false,
      warehouseType: ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    noEvidenceImage () {
      return ['0', '9'].includes(this.userInfo.multiChannelSenderFlg)
    }
  },
  methods: {
    openModalDownload (warehouseType) {
      this.isShowDownload = true
      this.warehouseType = warehouseType
    },
    closeModalDownload () {
      $('#productDownload').modal('hide')
      this.isShowDownload = false
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'reports') {
      let logParams = {
        name: eventCode.manage_products.report_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/Reports.vue